module.exports = __webpack_public_path__ + "img/ic_publicity_detail3_1.48b50208.png";